import { DataEditorProps, ValueViewerProps } from 'common/types/scalarSpreadsheet';
import { SelectValueViewer } from 'components';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS } from 'pages/FundInvestments/common/constants';
import { normalizeHiddenCell } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet/config/createParser/utils/normalizeHiddenCell';
import { normalizePercentageCell } from 'pages/FundInvestments/hooks/useFundInvestmentMarketAdjustmentSheet/config/createParser/utils/normalizePercentageCell';
import { getPercentileOptions } from 'pages/ValuationsAllocation/util';
import { getNumberValue } from 'utilities';
import { HandlePercentileSelectionCellsParams } from './handlePercentileSelectionCells.types';

// This constant cannot be imported from fundInvestments/common/constants due to circular dependency issues
const FUND_INVESTMENTS_PERCENTILE_OPTIONS = getPercentileOptions(new Array(99).fill(0));

const { metric_selection_as_of_market_date: METRIC_SELECTION_AS_OF_MARKET_DATE, percentage_change: PERCENTAGE_CHANGE } =
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS;

const handlePercentileSelectionCells = (params: HandlePercentileSelectionCellsParams): void => {
  const { allComparisonsExpression, cell, colNumber, key, optionKey, percentileSelection } = params;

  switch (colNumber) {
    case METRIC_SELECTION_AS_OF_MARKET_DATE.column:
      Object.assign(cell, {
        customKey: optionKey,
        dataEditor: (props: DataEditorProps) => (
          <GridSelect
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: GridSelect is not typed
            options={FUND_INVESTMENTS_PERCENTILE_OPTIONS}
            optionsTextAlign="left"
            {...props}
          />
        ),
        dbType: 'number',
        gridType: 'number',
        hidden: false,
        isRequired: true,
        readOnly: false,
        value: getNumberValue(percentileSelection),
        valueViewer: (props: ValueViewerProps) => (
          <SelectValueViewer options={FUND_INVESTMENTS_PERCENTILE_OPTIONS} {...props} />
        ),
      });
      break;

    case PERCENTAGE_CHANGE.column:
      normalizePercentageCell(cell);

      Object.assign(cell, {
        customKey: key,
        expr: `=PERCENTILE(FILTER_ENABLED([${allComparisonsExpression}]), ${optionKey})`,
      });
      break;

    default:
      normalizeHiddenCell(cell);
      break;
  }
};

export default handlePercentileSelectionCells;
